module.exports = __webpack_public_path__ + "img/arrow-double-down.cc4436ea.png";